import React from 'react';
import classNames from 'classnames';
import PropTypes from 'prop-types';

const BaseCardHeader = ({
  children,
  className,
  id,
  title,
  noBorder = false,
  secondaryFullWidth = false,
}) => {
  const headerClass = classNames({
    'bg-white rounded-t': true,
    'border-solid border-b border-medium-border-blue': !noBorder,
  }, className);

  const mappedChildren = React.Children.map(children, (child, index) => (
    <div
      className={classNames({
        'flex-grow': secondaryFullWidth,
      }, 'relative', 'flex-none', 'ml-3')}
      key={index}
    >
      {child}
    </div>
  ));

  return (
    <div
      {...(id ? { id } : {})}
      {...(id ? { 'data-testid': id} : {})}
      className={headerClass}
    >
      <div className="flex flex-row justify-between">
        <h2 className="flex-auto p-4 pb-3">{title}</h2>
        <div className="flex-auto py-2 pr-4 pl-0 flex flex-row justify-end items-center">
          {mappedChildren}
        </div>
      </div>
    </div>
  );
};

BaseCardHeader.displayName = 'BaseCardHeader';

BaseCardHeader.propTypes = {
  children: PropTypes.node,
  className: PropTypes.string,
  id: PropTypes.string,
  title: PropTypes.string,
  noBorder: PropTypes.bool,
  secondaryFullWidth: PropTypes.bool,
}

export default BaseCardHeader;
